import { render } from "./AddUserView.vue?vue&type=template&id=6fdbd8a0&scoped=true&ts=true"
import script from "./AddUserView.vue?vue&type=script&lang=ts"
export * from "./AddUserView.vue?vue&type=script&lang=ts"

import "./AddUserView.vue?vue&type=style&index=0&id=6fdbd8a0&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdbd8a0"]])

export default __exports__